/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2021-09-01 14:12:39
 * @LastEditors: zhanghang
 * @LastEditTime: 2021-09-14 17:05:18
 */
export const DsfNavMenu=dsf.defineLazyComponent('DsfNavMenu',()=>require('./navMenu'));
export const DsfCalendarNav=dsf.defineLazyComponent('DsfCalendarNav',()=>require('./calendarNav'));
export const DsfBanner=dsf.defineLazyComponent('DsfBanner',()=>require('./banner.vue'));
export const DsfIndicatorPanel=dsf.defineLazyComponent('DsfIndicatorPanel',()=>require('./indicatorPanel'));
export const DsfNavCatalogue=dsf.defineLazyComponent('DsfNavCatalogue',()=>require('./navCatalogue'));
export const DsfConvenientMenu=dsf.defineLazyComponent('DsfConvenientMenu',()=>require('./convenientMenu'));